<div class="loading" [hidden]="!loading">
  <div class="loader">Loading...</div>
</div>
<div
  class="scrollable-y m-15 practice-info"
  style="padding-bottom: 100px; background: #f6f7fa"
>
  <div class="tour-modal-wrapper" *ngIf="couponModal">
    <div class="tour-modal text-center" style="padding: 30px">
      <h4 style="font-size: 22px; font-weight: 900">Redeem a coupon</h4>
      <p style="margin-bottom: 30px">Have a coupon code? Redeem it here.</p>
      <div>
        <label for="couponInput01">Coupon</label>
        <input
          id="couponInput01"
          [(ngModel)]="coupon"
          type="text"
          class="form-control"
          placeholder=""
        />
        <br />
        <button class="btn btn-primary" (click)="apply_coupon()">
          Submit Coupon
        </button>
      </div>
      <i class="feather x" (click)="couponModal = false"></i>
    </div>
    <div class="tour-modal-backdrop"></div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div class="pages-header" style="background-color: #fff">
        <h1 class="mobile-move-title">Manage Practice</h1>
      </div>
      <div class="panel panel-default" id="subscription">
        <div class="panel-heading">
          <h2 style="margin-top: 16px">Subscription</h2>
        </div>
        <div class="panel-body">
          <div
            *ngIf="sharedDataService.subscriptionType == 'free'"
            style="margin: 16px 0"
          >
            <h4>
              Upgrade now and get Client Hub’s complete client collaboration and
              workflow management experience.
            </h4>
            <p style="margin-bottom: 24px">
              Start on a paid plan today and if you set up time with our
              customer success team, you even get a 14-day money back guarantee.
            </p>
            <a
              href="https://clienthub.app/product-tour"
              target="_blank"
              rel="noreferrer noopener"
              rel="noopener noreferrer"
              class="btn btn-primary-light"
              style="margin-right: 16px"
              >Learn More</a
            >
            <a
              href="https://clienthub.app/#pricing"
              target="_blank"
              rel="noreferrer noopener"
              rel="noopener noreferrer"
              class="btn btn-primary-light"
              >Pricing</a
            >
          </div>
          <div class="row" [hidden]="user?.id != company?.owner">
            <div class="col-sm-12 col-md-6">
              <a (click)="goToCustomerPortal()" class="btn btn-primary">
                Update your subscription on our billing portal
              </a>
            </div>
          </div>
          <div class="row" [hidden]="user?.id == company?.owner">
            <div class="col-sm-12 col-md-6">
              <p>
                The Subscriber User of Client Hub (the person who signed up your
                firm) can manage the subscription: Add / Update Payment Method,
                Change Subscription Plan etc.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Manage Practice Staff -->
  <div class="row">
    <div class="col-md-12">
      <div class="panel panel-default">
        <div class="panel-heading">
          <div class="row d-flex align-items-center">
            <div class="col-md-8 col-xxl-6">
              <h2 style="margin-top: 16px">Manage Firm Users</h2>
            </div>
            <div class="col-md-4">
              <button
                class="btn btn-primary"
                *ngIf="sharedDataService.data.access_level == 1"
                (click)="openAddAccountantModal(company)"
              >
                <i class="feather plus visible-xs"></i
                ><span class="hidden-xs">Invite Staff</span>
              </button>
            </div>
          </div>
        </div>
        <div class="panel-body">
          <div class="table-responsive">
            <table class="table table-borderless table-striped">
              <thead>
                <tr>
                  <th></th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Role</th>
                  <th *ngIf="sharedDataService.data.access_level == 1">
                    2FA Enabled?
                  </th>
                  <th
                    *ngIf="sharedDataService.data.access_level == 1"
                    width="165"
                  >
                    Actions
                  </th>
                  <th
                    *ngIf="sharedDataService.data.access_level == 1"
                    width="110"
                  ></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let accountant of company.accountants">
                  <td class="td-avatar">
                    <img
                      class="avatar avatar-32"
                      src="{{ accountant.user.pictureUrl }}"
                    />
                    <!-- <div class="avatar avatar-32">
                      <div
                        class="avatar-inicitials"
                        initials
                        [name]="accountant.user.full_name"
                      ></div>
                    </div> -->
                  </td>
                  <td>
                    {{ accountant.user.first_name }}
                    {{ accountant.user.last_name }}
                  </td>
                  <td>{{ accountant.user.email }}</td>
                  <td
                    *ngIf="
                      accountant.access_level == 1 &&
                      sharedDataService.data.access_level == 2
                    "
                  >
                    Admin
                  </td>
                  <td
                    *ngIf="
                      accountant.access_level == 2 &&
                      sharedDataService.data.access_level == 2
                    "
                  >
                    Staff
                  </td>

                  <td *ngIf="sharedDataService.data.access_level == 1">
                    <select
                      class="transparent-select"
                      (change)="changeAccessLevel(accountant)"
                      [(ngModel)]="accountant.access_level"
                      *ngIf="accountant.user.id !== company.owner"
                    >
                      <option value="1">Admin</option>
                      <option value="2">Staff</option>
                    </select>
                    <div *ngIf="accountant.user.id == company.owner">
                      Subscriber
                    </div>
                  </td>
                  <td *ngIf="sharedDataService.data.access_level == 1">
                    {{ accountant.is_2fa_enabled ? "Yes" : "No" }}
                  </td>
                  <td class="center-mobile">
                    <a
                      (click)="openAccountantAssignmentsModal(accountant)"
                      *ngIf="
                        accountant.access_level == 2 &&
                        sharedDataService.data.access_level == 1
                      "
                      ><i class="feather user-check visible-xs"></i
                      ><span class="hidden-xs">Manage Assignments</span></a
                    >
                    <!-- <a
                      (click)="
                        checkForAssignments(
                          accountant.user.id,
                          staffHasJobsConfirmation,
                          deleteStaffConfirmation
                        )
                      "
                      *ngIf="
                        accountant.access_level == 2 &&
                        sharedDataService.data.access_level == 1
                      "
                    > -->
                    <a
                      (click)="newDelete(accountant.user.id)"
                      *ngIf="
                        accountant.access_level == 2 &&
                        sharedDataService.data.access_level == 1
                      "
                    >
                      <i class="feather user-check visible-xs"></i
                      ><span class="hidden-xs">Remove Staff Member</span></a
                    >
                  </td>
                  <!-- <td *ngIf="data.access_level == 1" class="text-right"><a *ngIf="accountant.access_level == 2 && data.access_level == 1" class="color-red hover"><i class="feather trash-2 visible-xs"></i><span class="hidden-xs">Remove</span></a></td> -->
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="panel-body" *ngIf="company.pending_accountants != ''">
          <hr />
          <h4>Pending Invites</h4>
          <table class="table table-borderless table-striped">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Access Level</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let accountant of company.pending_accountants">
                <td>{{ accountant.name }}</td>
                <td>
                  {{ accountant.email }}
                </td>
                <td>
                  {{ accountant.access_level == 1 ? "Admin" : "Staff" }}
                </td>
                <td class="text-left">
                  <a
                    class="color-red-hover"
                    (click)="
                      removeInvite(accountant.id, removeInviteConfirmation)
                    "
                    ><i class="feather trash visible-xs"></i
                    ><span class="hidden-xs">Remove</span></a
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <!-- IF USER IS ADMIN -->
  <!-- Manage Roles Permissions -->
  <div class="row">
    <div class="col-md-12">
      <div class="panel panel-default">
        <div class="panel-heading">
          <div class="row d-flex align-items-center">
            <div class="col-md-12">
              <h2 style="margin-top: 16px">Manage Roles Permissions</h2>
            </div>
          </div>
        </div>
        <div class="panel-body">
          @for (crp of rolesAndPermissions; track crp; let lastRole = $last) {
            <div class="row mt-4 pb-5">
              <div class="col-md-4 col-xxl-3">
                <div class="sticky-top" style="top: 16px">
                  <h4 class="fw-bold role-title">
                    {{ crp.role.name_readable }} Permissions
                  </h4>
                  <p class="role-subtitle">
                    You can manage the permissions of your
                    {{ crp.role.name_readable }} members.
                  </p>
                </div>
              </div>

              <div class="col-md-8 col-xxl-6">
                <div class="permissions-set">
                  <h5 class="fw-bold mb-4">Permissions</h5>

                  @for (
                    rp of crp.permissions;
                    track rp;
                    let lastPermission = $last
                  ) {
                    <div class="switch-toggle">
                      <div class="toggle-wrapper">
                        <div class="toggle">
                          <input
                            type="checkbox"
                            class="check"
                            [checked]="rp.is_allowed"
                            (change)="
                              togglePermission(
                                crp.role.uuid,
                                rp.permission.uuid,
                                $event
                              )
                            "
                          />
                          <b class="b switch"></b>
                          <b class="b track"></b>
                        </div>
                      </div>
                      {{ rp.permission.name_readable }}
                    </div>
                    @if (!lastPermission) {
                      <hr />
                    }
                  }
                </div>
              </div>
            </div>

            @if (!lastRole) {
              <hr />
            }
          }
        </div>
      </div>
    </div>

    <!-- User has jobs assigned to them -->
    <ng-template #staffHasJobsConfirmation>
      <div class="modal-body rounded text-center">
        <h4>Are you sure?</h4>
        <p>The user selected for deletion has jobs assigned to them.</p>
        <p>
          In the next screen, you will be required to select who will inherit
          all Not Started, In Progress, On Hold, and Repeat Jobs.
        </p>
        <div class="row">
          <div class="col-6">
            <button
              type="button"
              class="btn btn-primary pull-left btn-block"
              (click)="openReassignModal(deleteStaffConfirmation)"
            >
              Next
            </button>
          </div>
          <div class="col-6">
            <button
              type="button"
              class="btn btn-default pull-right btn-block"
              (click)="decline()"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </ng-template>

    <!-- Archive/restore confirmation -->
    <ng-template #deleteStaffConfirmation>
      <div class="modal-body rounded text-center">
        <h4>Are you sure?</h4>
        <p>Do you really want to remove this staff member?</p>
        <div class="row">
          <div class="col-6">
            <button
              type="button"
              class="btn btn-danger pull-left btn-block"
              (click)="confirm()"
            >
              Remove
            </button>
          </div>
          <div class="col-6">
            <button
              type="button"
              class="btn btn-default pull-right btn-block"
              (click)="decline()"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #removeInviteConfirmation>
      <div
        class="modal-body text-center rounded"
        *ngIf="invite_being_removed !== null"
      >
        <div>
          <!-- Removing any user -->
          <h4>Are you sure?</h4>
          <p>
            Do you really want to remove this invite? The user will not be able
            to join this company anymore.
          </p>
        </div>

        <!-- Hide the buttons in case of archiving (removing last user) -->
        <div class="row">
          <div class="col-6">
            <button
              type="button"
              class="btn btn-danger pull-left btn-block"
              (click)="confirmInviteRemoval(invite_being_removed)"
            >
              Remove
            </button>
          </div>
          <div class="col-6">
            <button
              type="button"
              class="btn btn-default pull-right btn-block"
              (click)="decline()"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
      <input #qbCompanyName id="qbCompanyNameTxt" type="hidden" />
    </ng-template>

    <!-- Remove tag confirmation -->
    <ng-template #removeTagConfirmationModal>
      <div class="modal-body rounded text-center">
        <h4>Are you sure?</h4>
        <p>
          Do you really want to remove this tag? it will be removed from all
          clients and jobs.
        </p>
        <div class="row">
          <div class="col-6">
            <button
              type="button"
              class="btn btn-danger pull-left btn-block"
              (click)="removeTag(modalService.config.initialState._tag)"
            >
              Remove
            </button>
          </div>
          <div class="col-6">
            <button
              type="button"
              class="btn btn-default pull-right btn-block"
              (click)="modalRef.hide()"
            >
              No
            </button>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
